import DeclaracionJuradaService from "../provider/DeclaracionJurada/DeclaracionJuradaService";
import { SUCCESS, ERROR, WARNING } from "../common/Util";
import {
	CHANGE_APP_PROPS,
	CHANGE_DECLARACION_JURADA_PROPS
} from "./ActionConstants";
import _ from "lodash";

export function actionGetDeclaracionJuradasList(
	searchText,
	mes,
	anio,
	page,
	limit,
	status
) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetDeclaracionJuradaList(searchText, mes, anio, page, limit, status)
			.then(response => {
				dispatch({
					type: CHANGE_DECLARACION_JURADA_PROPS,
					props: {
						declaracionJuradasList: response ? response : [],
						total: !_.isEmpty(response) ? response[0].cantidad : 0
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetDeclaracionJuradaList(
	searchText,
	mes,
	anio,
	offset,
	limit,
	status
) {
	let response = await DeclaracionJuradaService.getDeclaracionJuradaList(
		searchText,
		mes,
		anio,
		offset,
		limit,
		status
	);
	return response;
}

export function actionUpdateDeclaracionJurada(values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		asyncUpdateDeclaracionJurada(values)
			.then(response => {
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			})
			.catch(error => {
				//TODO
				if (error.code && error.code === 50015202) {
					callback(WARNING);
				} else {
					callback(ERROR);
				}
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateDeclaracionJurada(values) {
	let response = await DeclaracionJuradaService.updateDeclaracionJurada(values);
	return response;
}

export function actionDeleteDeclaracionJurada(declaracionJuradaId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteDeclaracionJurada(declaracionJuradaId)
			.then(response => {
				//TODO
				if (response.code && response.code === 41215203) {
					callback(WARNING);
				} else {
					callback(SUCCESS);
				}
			})
			.catch(error => {
				callback(ERROR);
			});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncDeleteDeclaracionJurada(declaracionJuradaId) {
	//TODO
	let response = await DeclaracionJuradaService.deleteDeclaracionJurada(
		declaracionJuradaId
	);
	return response;
	// for(let index in listPrueba){
	// 	if(listPrueba[index]._id == declaracionJuradaId){
	// 		listPrueba.splice(index,1);
	// 	}
	// }
	// return declaracionJuradaId;
}

export function actionChangeDeclaracionJuradaProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_DECLARACION_JURADA_PROPS,
			props: props
		});
	};
}

export function actionProcesarExcel(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Procesando"
			}
		});
		asyncProcesarExcel(values)
			.then(response => {
				callback(SUCCESS, response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			});
	};
}

async function asyncProcesarExcel(values) {
	var formData = new FormData();
	formData.append("type", "file");
	formData.append("file", values.archivoExcel);
	let response = await DeclaracionJuradaService.procesarExcel(
		formData,
		values.mes,
		values.anio
	);
	return response;
}

export function actionCreateDJ(idTempDJ, isNewDJ, month, year, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncCreateDJ(idTempDJ, isNewDJ, month, year)
			.then(response => {
				callback(response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncCreateDJ(idTempDJ, isNewDJ, month, year) {
	let response = await DeclaracionJuradaService.createDJ(
		idTempDJ,
		isNewDJ,
		month,
		year
	);
	return response;
}

export function actionCheckPeriodo(month, year, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Verificando"
			}
		});
		Promise.all([
			asyncCheckPeriodoFixedContribution(month, year),
			asyncCheckPeriodo(month, year)
		])
			.then(response => {
				callback(response[0], response[1]);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			});
	};
}

async function asyncCheckPeriodo(month, year) {
	let response = await DeclaracionJuradaService.checkPeriodo(month, year);
	return response;
}

async function asyncCheckPeriodoFixedContribution(month, year) {
	let response = await DeclaracionJuradaService.checkPeriodoFixedContribution(
		month,
		year
	);
	return response;
}

export function actionGetDJDetail(idDJ, page, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetDJDetail(idDJ, page, limit)
			.then(response => {
				dispatch({
					type: CHANGE_DECLARACION_JURADA_PROPS,
					props: {
						djDetail: response ? response : [],
						totalDJDetail: !_.isEmpty(response) ? response[0].cantidad : 0
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetDJDetail(idDJ, offset, limit) {
	let response = await DeclaracionJuradaService.getDJDetail(
		idDJ,
		offset,
		limit
	);
	return response;
}

export function actionPrintDJ(idDJ, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncPrintDJ(idDJ)
			.then(response => {
				callback(response.fileName);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncPrintDJ(idDJ) {
	return await DeclaracionJuradaService.printDJ(idDJ);
}



// WEBPACK FOOTER //
// ./src/actions/DeclaracionJuradaActions.js